export { FroalaViewDirective } from './view.directive';
export { FroalaViewModule } from './view.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/angular-froala-wysiwyg/view/index.js
// module id = ../../../../angular-froala-wysiwyg/view/index.js
// module chunks = 16